define('strings',["config"], function (config) {
    if (config.lang === 'fr') {
        return {
            expired: "TERMINÉES",
            ending_soon: "BIENTÔT TERMINÉES",
            new: "NOUVELLES",
            learn_more: "EN SAVOIR PLUS",
            cta1: "var s=s_gi('sssamsung4cafr,sssamsung4mstglobal'); s.linkTrackVars='eVar33,events'; s.linkTrackEvents='event45'; s.eVar33='ca_fr:promotions:OFFERID_cta1'; s.events='event45'; s.tl(this,'o','OFFERID_cta1');",
            cta2: "var s=s_gi('sssamsung4cafr,sssamsung4mstglobal'); s.linkTrackVars='eVar33,events'; s.linkTrackEvents='event45'; s.eVar33='ca_fr:promotions:OFFERID_cta2'; s.events='event45'; s.tl(this,'o','OFFERID_cta2');"
        };
    } else {
        return {
            expired: "EXPIRED",
            ending_soon: "ENDING SOON",
            new: "NEW",
            learn_more: "LEARN MORE",
            cta1: "var s=s_gi('sssamsung4ca,sssamsung4mstglobal'); s.linkTrackVars='eVar33,events'; s.linkTrackEvents='event45'; s.eVar33='ca:promotions:OFFERID_cta1'; s.events='event45'; s.tl(this,'o','OFFERID_cta1');",
            cta2: "var s=s_gi('sssamsung4ca,sssamsung4mstglobal'); s.linkTrackVars='eVar33,events'; s.linkTrackEvents='event45'; s.eVar33='ca:promotions:OFFERID_cta2'; s.events='event45'; s.tl(this,'o','OFFERID_cta2');"
        };
    }
});

